import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './Link.module.scss';
import { useRouteContext } from 'ui/contexts/RouteContext';
import { UI_Icon } from '../../Media/Icon/Icon';

import RightArrow from 'ui/icons/icon-right-button-arrow.svg';
import RightArrowSmall from 'ui/icons/icon-right-button-arrow-small.svg';

export interface UI_LinkProps {
	children?: React.ReactNode;
	style?: 'primary' | 'sm' | 'md' | 'lg' | 'xl';
	cssStyle?: React.CSSProperties;
	inheritsColor?: boolean;
	color?: 'violet';
	ariaLabel?: string;
	className?: string;
	href?: string;
	target?: string;
	title?: string;
	rel?: string;
	clickHandler?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	locale?: string;
	iconLink?: boolean;
	noUnderline?: boolean;
	underline?: boolean;
	globalTheme?: string;
}

export const UI_Link = forwardRef<HTMLAnchorElement, UI_LinkProps>(
	(
		{
			children,
			style,
			cssStyle,
			inheritsColor,
			ariaLabel,
			className,
			href,
			target,
			title,
			rel,
			clickHandler,
			locale,
			color,
			iconLink,
			noUnderline,
			underline,
			globalTheme,
		},
		ref,
	) => {
		const routeContext = useRouteContext();
		const routeHandler = routeContext?.routeHandler;

		return (
			<>
				{!href && !clickHandler ? (
					<>{children}</>
				) : (
					<a
						ref={ref}
						href={href}
						target={target}
						title={title}
						rel={rel}
						aria-label={ariaLabel}
						style={cssStyle}
						className={classNames(
							styles.Link,
							styles[`Link___${style}`],
							styles[`Link___${color}`],
							{
								[styles.Link___icon]: iconLink,
							},
							{
								[styles.Link___noUnderline]: noUnderline,
							},
							{
								[styles.Link___underline]: underline,
							},
							{
								[styles.Link___inheritsColor]: inheritsColor,
							},
							className,
						)}
						onClick={(event) => {
							if (clickHandler) {
								clickHandler(event);
								return;
							}

							// Only run routeHandler when no clickHandler is provided.
							routeHandler?.(event, href, locale, target);
						}}
					>
						{children}

						{iconLink &&
							(globalTheme === 'kogp' ? (
								<UI_Icon size="sm" className={classNames(styles.Link_iconContainer)}>
									<RightArrowSmall />
								</UI_Icon>
							) : (
								<UI_Icon size="md" className={classNames(styles.Link_iconContainer)}>
									<RightArrow />
								</UI_Icon>
							))}
					</a>
				)}
			</>
		);
	},
);

UI_Link.displayName = 'Link';
